import { createAPI } from '@common'
// MediaCloudArticleEdit
export default {
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0efubjm0tubuvt', 'get', config),
  // 打印
  putPrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0qsjou', 'put', config),
  // 分享
  postArticleShare: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0tibsf', 'post', config),
  // 分享状态
  getArticleShare: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0tibsf0tubuvt',
      'post',
      config
    ),
  // 设置类型
  postArtcleClassify: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0dmbttjgz',
      'PUT',
      config
    ),
  // 提交审核
  postFinalSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0tvcnju0bveju',
      'post',
      config
    ),
  // 获取根节点
  getTreeNodes: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0usff', 'get', config),
  postUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0obnft', 'post', config, {
      neverLoading: true
    }),
  // 删除稿件
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0efmfuf',
      'delete',
      config
    ),
  // 下载稿件
  putDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0epxompbe',
      'put',
      config,
      {
        timeout: 900000
      }
    ),
  // 查询取稿文件夹树
  getTakeTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0ublf0usff', 'get', config),
  // 取稿提交
  postTake: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0ublf', 'post', config),
  // 查询追回稿件列表
  getRecoverList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0sfdpwfs0mjtu',
      'get',
      config
    ),
  // 个人部门库文件夹列表
  getRecoverFolderList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0sfdpwfs0gpmefsMjtu',
      'get',
      config
    ),
  // 部门库稿件追回提交（新
  putDocRecover: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0epdSfdpwfs',
      'post',
      config
    ),
  // 稿件追回提交（旧
  putRecover: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0sfdpwfs',
      'put',
      config
    ),
  // 查询送稿文件夹树
  getSendTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0tfoe0usff', 'get', config),
  // 送稿
  postSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0tfoe', 'post', config),
  // 解锁
  putUnlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0vompdl', 'put', config),
  // 复制
  putCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0dpqz', 'put', config),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0joju', 'get', config),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0tbwf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 获取稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0efubjm', 'get', config, {
      timeout: 90000
    }),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0efubjm', 'get', config, {
      timeout: 90000
    }),

  //  读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getOpenEditUserPapers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0tjho0mjtuebub', 'get', config),

  getOpenEditUserPapersColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0tjho0dpmvnot', 'get', config),
  // 给定一个栏目，获取版次
  getOpenEditUserPapersLayouts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0tjho0mbzpvut', 'get', config),
  // 获取拥有图片制作人员的名单（全媒体采编发提供的接口）
  getOpenEditPicmakeUsersNew: (config) =>
    //原接口: /mediax-open/sign/picmake/users
    createAPI('customEncryptApiName-1/0nfejby.pqfo0tjho0qjdnblf0vtfst', 'get', config, {
      neverLoading: true
    }),
  //  读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getNewsEditUserPapers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0mjtuebub', 'get', config),

  getNewsEditUserPapersColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0dpmvnot', 'get', config),
  // 给定一个栏目，获取版次
  getNewsEditUserPapersLayouts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0mbzpvut', 'get', config),
  // 获取拥有图片制作人员的名单（全媒体采编发提供的接口）
  getNewsEditPicmakeUsersNew: (config) =>
    //原接口: /mediax-open/sign/picmake/users
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0qjdnblf0qbqfs0vtfst', 'get', config, {
      neverLoading: true
    }),

  // 签发稿件到全媒体采编发（全媒体采编发提供的接口）
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),

  // 签发稿件到全媒体采编发（全媒体采编发提供的接口）
  postNewsEditArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0qbqfs0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到报纸（全媒体采编发提供的接口，通用定义接口不是重复
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0qbqfs0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到 APP
  postAppEditArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bqq0tjho0gpsxbse', 'post', config),
  // 签发稿件到 网站
  postWebEditArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0xfc0tjho0gpsxbse', 'post', config),
  // 签发稿件到 微信
  postWXEditArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0xy0tjho0gpsxbse', 'post', config),
  // 签发稿件到 视频号
  postVideosArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0wjefp0tjho0gpsxbse', 'post', config),
  // 签发稿件到 媒体号
  postMoArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0nfejb0tjho0gpsxbse', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),

  // 获取全部自定义审校列表
  postProofListdata: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0f60mjtuebub', 'post', config, vconfig),
  // 智能审校
  postProofText: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0ufyu0tzod', 'post', config, {
      ...vconfig,
      timeout: 60000,
      isHideErrorMessage: true,
      isSimpleSecurity: true
    }),
  // 智能审校
  postProofCorrectExternal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0njev0iunm0tzod', 'post', config, {
      ...vconfig,
      timeout: 60000,
      isHideErrorMessage: true,
      isSimpleSecurity: true
    }),
  // 智能审校误报
  postProofProblem: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0qspcmfn', 'post', config, {
      ...vconfig
    }),

  // 智能审校html
  postProofHTML: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0iunm0w30btzod', 'post', config, {
      ...vconfig,
      timeout: 60000,
      isHideErrorMessage: true,
      isSimpleSecurity: true
    }),
  // 智能审校html
  postProofHTMLSync: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0iunm0w40tzod', 'post', config, {
      ...vconfig,
      timeout: 60000,
      isHideErrorMessage: true,
      isSimpleSecurity: true
    }),
  // 获取任务结果
  getProofReviewResult: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0w30sftvmu', 'get', config, vConfig),
  // 获取任务进度
  getProofReviewProgress: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0qsppg0qsphsftt', 'get', config, vConfig),
  // 三方审校通用接口
  postCustomProofText: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0qsppg', 'post', config, {
      ...vconfig,
      timeout: 60000,
      isHideErrorMessage: true
    }),
  // 智能标题
  postAITitle: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0ujumf', 'post', config, vconfig),
  // 智能标题-log
  postAITitleLog: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bj0tbwf', 'post', config, vconfig),
  // 发起查重任务
  sendTaskWhole: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0epdtjn0ubtl0tfoe', 'post', config, vconfig),
  // 发起查重任务
  sendTaskPart: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0epdtjn0ubtl0tfoe', 'post', config, vconfig),
  // 获取任务结果
  postTaskResult: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0epdtjn0ubtl0sftvmu', 'post', config, vconfig),
  // 获取核校列表
  getTaskRef: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0epdtjn0sfg', 'get', config, vconfig),
  // 获取核校列表引用详情页
  getRefDocDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0epdtjn0sfg0efubjm', 'get', config, vconfig),

  // 唱校接口
  transcriberSend: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0usbotdsjcfs0ubtl0tfoe', 'post', config, vconfig),
  // 唱校接口
  transcriberCopy: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0epdtjn0dpqz',
      'post',
      config,
      vconfig
    ),
  // 部门库签发到畅享全媒体稿源稿库接口
  signRemoteRootForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0ofxtfeju0tjho0sppu0gpxbse', 'post', config, {
      timeout: 90000
    }),
  // 部门库签发到畅享全媒体部门库接口
  signRemoteEditForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0ofxtfeju0tjho0feju0gpxbse', 'post', config, {
      timeout: 90000
    }),
  // 稿件置顶
  postArticlesSortingTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0nzbsujdmf0tfuUpq',
      'post',
      config
    ),

  // 取消置顶
  postArticlesUnSetTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0nzbsujdmf0voTfuUpq',
      'post',
      config
    ),
  // 取消签发
  postArticlesFeedbackDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0gffecbdl0efmfuf',
      'post',
      config
    ),
  // 判断是否有回收站权限
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0hfuSfdzdmf', 'get', config),

  // 还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  // 彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0efmfufSfbm',
      'post',
      config,
      vconfig
    ),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60bdujpot0efubjmbdujpot', 'get', config),

  // 为打印功能定制的 批量查询稿件信息接口（柳爱霞
  postArticlePrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0qsjou', 'post', config),

  // 报纸采编获取拥有图片制作人员的名单（全媒体采编发提供的接口）
  getNewsEditPicmakeUsersNewPaperEdit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0nfejby.qbqfs0tjho0qjdnblf0qbqfs0vtfst',
      'get',
      config,
      {
        neverLoading: true
      }
    ),
  // 报纸采编读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getNewsEditUserPapersPaperEdit: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0nfejby.qbqfs0tjho0mjtuebub',
      'get',
      config,
      vconfig
    ),

  getNewsEditUserPapersColumnsPaperEdit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0nfejby.qbqfs0tjho0dpmvnot', 'get', config),
  // 给定一个栏目，获取版次
  getNewsEditUserPapersLayoutsPaperEdit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0nfejby.qbqfs0tjho0mbzpvut', 'get', config),

  // 魔方开放接口 - 获取h5页面地址
  getArticleMfH5: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0fospmm0pqfo0ng0i6', 'get', config, vconfig),
  // 魔方开放接口 - h5/js-sdk 调用魔方能力所需参数
  getArticleMfSignParams: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0fospmm0pqfo0ng0tjhoQbsbnt', 'get', config, vconfig),
  // 获取稿件发布设置信息
  getArticlesPubInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0qvcJogp', 'GET', config),
  // 签发稿件到期刊
  postJournalArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0kpvsobm0tjho0gpxbse', 'post', config, {
      timeout: 90000
    }),
  // 新-稿件预览接口
  postNewPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmft0bqqQsfWjfx', 'post', config)
}
